// src/hooks/useOwnerAudit.ts — server-backed audit log hook.
import { useOwnerList } from './useOwnerList';
import { ownerService } from '@/core/services/ownerService';

export function useOwnerAudit() {
  return useOwnerList(() => ownerService.getAudit());
}
